import { Container } from 'hypo-container';
import { EcommStore } from '../internal/stores/EcommStore';
import { ServiceBusController } from './ServiceBusController';

export const serviceNames = {
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    ecommStore: 'ECOMM_STORE'
};

export const diContainer = new Container();

diContainer
    .register(serviceNames.ecommStore, () => new EcommStore())
    .register(
        serviceNames.serviceBusController,
        (c) => new ServiceBusController(c.get(serviceNames.ecommStore))
    );

export const getServiceBusController = () => {
    // This is needed to run the serviceBus decorators
    diContainer.get(serviceNames.serviceBusController);
};
